import * as React from "react";
import styled from "styled-components";

interface TitleBlockProps {
  /** ID ZEWNĘTRZEGO KOMPONENTU => DO NAWIGACJI */
  id?: string

  /** PIERWSZA LINIA => CZARNY TEXT */
  firstLineBlackStart: string

  /** PIERWSZA LINIA => NIEBIESKI TEXT */
  firstLineBlue: string

  /** PIERWSZA LINIA => CZARNY TEXT */
  firstLineBlackEnd: string

  /** DRUGA LINIA => TEXT */
  secondLineText: string | string[]

  /** PADDING TOP => OVERRIDE DEFAULT 55PX */
  paddingTop?: number

  /** PADDING BOTTOM => OVERRIDE DEFAULT 55PX */
  paddingBottom?: number
}

const TitleBlock = (props: TitleBlockProps) => {
  const {firstLineBlackStart,firstLineBlue,firstLineBlackEnd,secondLineText,paddingTop,paddingBottom} = props;

  // SPRAWDZANIE CZY DRUGA LINIA JEST ARRAY
  const secondLineTextIsAList: boolean = Array.isArray(secondLineText);

  // ZWRACANIE DANYCH
  return (
    <div className="goodgrowth-theme-styles">
      <TitleBlockIdWrapper id={props.id}/>
      <TitleBlockWrapper className="introtext" paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <div className="row">
          <div className="col-sm-12">
            <h2 className="title-block-header">{firstLineBlackStart} <span>{firstLineBlue}</span> {firstLineBlackEnd}</h2>
            {!secondLineTextIsAList && <p className="text-center">{secondLineText}</p>}
            {secondLineTextIsAList && (secondLineText as string[]).map((secondLineTextLine: string, i: number) => <p key={i} className="text-center">{secondLineTextLine}</p>)}
          </div>
        </div>
      </TitleBlockWrapper>
    </div>
  )
};

/** STYLES */

const TitleBlockWrapper: any = styled.section`
  h2.title-block-header {
    font-family: 'Raleway' !important;
  }
  ${(props: any) => typeof props.paddingTop === 'number' && `padding-top: ${props.paddingTop}px !important;`}
  ${(props: any) => typeof props.paddingBottom === 'number' && `padding-bottom: ${props.paddingBottom}px !important;`}
`;

const TitleBlockIdWrapper = styled.div`
  display: block;
  height: 63px;
  margin-top: -63px;
  visibility: hidden;
  position: absolute;
`;

export default TitleBlock


// WEBPACK FOOTER //
// ./src/layouts/title-block/title-block.tsx